module.exports = "/_next/static/images/ico-home-7380a736e76b2c4a2e04031d91e99fd2.svg";